module.exports = __webpack_public_path__ + "img/img-servidor.05c38c12.webp";